module.exports = __webpack_public_path__ + "static/media/explorations.2ba9efa1.png";